import React from 'react';
import { ConfigProvider } from "antd";
import {ThemeProvider} from 'styled-components';
import themes from './theme';

const antdTheme = {
    token: {
        colorPrimary: '#4482FF',
        borderRadius: 6,
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        colorLink: '#4482FF',
        colorSuccess: '#00b16a',
        colorWarning: '#ffbf00',
        colorError: '#f64744',
    },
};

export default function AppThemeProvider({children}) {
    return (
        <ConfigProvider theme={antdTheme}>
            <ThemeProvider theme={themes}>{children}</ThemeProvider>
        </ConfigProvider>
    )
}
